var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIcnX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3807 2.22168H25.3164L16.718 12.0491L26.8333 25.422H18.9131L12.7097 17.3114L5.6116 25.422H1.67349L10.8703 14.9105L1.16666 2.22168H9.28795L14.8953 9.63507L21.3807 2.22168ZM19.9993 23.0663H22.1802L8.10295 4.45367H5.76269L19.9993 23.0663Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcnX);
export default __webpack_public_path__ + "static/media/social-icn-x.551b34e3c3cd19613bf3de23267bbbf2.svg";
export { ForwardRef as ReactComponent };